import React, { FC } from "react";
import RefundUnavailable from "./RefundUnavailable";

const Refund: FC = () => <RefundUnavailable />;

export default Refund;
